import {
  combinedStyleSelector,
  createShallowEqualSelector,
  getColorSelector,
  getSettingSelector,
  makeBorderStyleSelector,
  makeBoxShadowStyleSelector,
  makePaddingStyleSelector,
  TargetSelector
} from "@client/selectors";
import { createSelector } from "reselect";

export const makeImageContainerStyleSelector = () => combinedStyleSelector(TargetSelector.Entity, ["margin"], "image");

export const makeStyleSelector = () => {
  const backgroundColorSelector = getColorSelector(TargetSelector.Entity, "backgroundColor", "product");

  const borderStyleSelector = makeBorderStyleSelector(TargetSelector.Entity, "product");
  const boxShadowStyleSelector = makeBoxShadowStyleSelector(TargetSelector.Entity, "product");

  return createSelector(
    [borderStyleSelector, boxShadowStyleSelector, backgroundColorSelector],
    (borderStyle, boxShadowStyle, backgroundColor): React.CSSProperties => ({
      ...borderStyle,
      ...boxShadowStyle,
      backgroundColor
    })
  );
};

export const makeContentStyleSelector = () => {
  const horizontalAlignSelector = getSettingSelector(TargetSelector.Entity, "horizontalAlign", "content");
  const paddingStyleSelector = makePaddingStyleSelector(TargetSelector.Entity, "content");

  return createShallowEqualSelector(
    [horizontalAlignSelector, paddingStyleSelector],
    (horizontalAlign, padding): React.CSSProperties => ({
      display: "flex",
      flexDirection: "column",
      textAlign: horizontalAlign,
      ...padding
    })
  );
};
